import angular from 'angular';

import PrivilegeTemplatesListComponent from './privilege-templates-list-component';

export default angular.module('privilege-templates-list', []).component('privilegeTemplatesList', new PrivilegeTemplatesListComponent());



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/components/privilege-templates-list/privilege-templates-list-module.js